import PoolApi from '../api/pools'
import { push } from 'react-router-redux'

export const LOADPOOLS_SEARCH = 'pools/LOADPOOLS_SEARCH'
export const LOADPOOLS_REQUESTED = 'pools/LOADPOOLS_REQUESTED'
export const LOADPOOLS = 'pools/LOADPOOLS'
export const LOADPOOLS_ERROR = 'pools/LOADPOOLS_ERROR'

export const search = (data) => {
  return dispatch => {
    dispatch(push({
      search: data
    }))
  }
}



export const loadPools = (data) => {
  return dispatch => {
    dispatch({
      type: LOADPOOLS,
      data: data
    })
  }
}

export const addOnClick = (locationSearch = '') => {
  return dispatch => {
    dispatch(push({
      pathname: '/pools/create',
      search: locationSearch
    }))
  }
}

export const bulkScheduleUpload = (locationSearch = '') => {
  return dispatch => {
    dispatch(push({
      pathname: '/restaurant-pool-schedule/csv',
      search: locationSearch
    }))
  }
}

export const loadPoolsAsync = (data) => {
  return dispatch => {
    dispatch({
      type: LOADPOOLS_REQUESTED,
      page: data.page,
      pool: data.pool,
      restaurant: data.restaurant,
      sortField: data.sortField,
      sortDirection: data.sortDirection,
      itemsPerPage: data.itemsPerPage
    })
  
    let offset = (data.page - 1) * data.itemsPerPage
  
    PoolApi.Summary({...data, offset:offset})
      .then(response => {
        return response.json() })
      .then(json => dispatch(loadPools(json)))
      .catch(function(error) {
        dispatch({
          type: LOADPOOLS_ERROR,
          error: error.message
        })
        console.log('There has been a problem with your fetch operation: ', error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/poolIndex.js